import { render, staticRenderFns } from "./FittingsClassification.vue?vue&type=template&id=28107524&scoped=true"
import script from "./FittingsClassification.vue?vue&type=script&lang=js"
export * from "./FittingsClassification.vue?vue&type=script&lang=js"
import style0 from "./FittingsClassification.vue?vue&type=style&index=0&id=28107524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28107524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28107524')) {
      api.createRecord('28107524', component.options)
    } else {
      api.reload('28107524', component.options)
    }
    module.hot.accept("./FittingsClassification.vue?vue&type=template&id=28107524&scoped=true", function () {
      api.rerender('28107524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsClassification/FittingsClassification.vue"
export default component.exports